/**
 * Resolve a hub/tabs definition: static `id` + `labelKey` → `{ id, label }` via t().
 * `labelKey` is an i18n key including namespace prefix (e.g. `people:lcr.tabs.calendar`).
 */
export function resolveTabs(tabs, t) {
  return tabs.map(({ id, labelKey, ...rest }) => ({
    id,
    label: t(labelKey),
    ...rest,
  }));
}
